/**
 * Professional — clean, business-appropriate. Calm slate-blue on near-black,
 * minimal glow, a legible system-ish sans for body and headings. For courses
 * (like Relay) that want a serious register over the space-station vibe, while
 * staying dark to match the platform.
 */
export const professional = {
  id: 'professional',
  name: 'Professional',
  assignable: true,
  mantine: {
    primaryColor: 'blue',
    fontFamily: 'Inter, system-ui, sans-serif',
    headings: { fontFamily: 'Inter, system-ui, sans-serif' },
  },
  cssVars: {
    '--bw-bg': 'linear-gradient(180deg, #131a26 0%, #0c111a 100%)',
    '--bw-body-color': '#dfe6ef',
    '--bw-panel-bg': 'rgba(22, 30, 44, 0.95)',
    '--bw-panel-border': 'rgba(120, 150, 190, 0.18)',
    '--bw-accent': 'rgba(96, 150, 220, 1)',
    '--bw-glow-color': 'rgba(96, 150, 220, 0.12)',
    '--bw-glow-text-color': 'rgba(96, 150, 220, 0.2)',
    '--bw-body-font': "'Inter', system-ui, sans-serif",
    '--bw-heading-font': "'Inter', system-ui, sans-serif",
    '--bw-heading-letter-spacing': '0.01em',
    '--bw-content-base': '1.0625rem',
  },
}
